import React, { Component, Fragment } from "react";
import DispatchProps from "../../../utils/DispatchProps";
import * as _ from "lodash";
import { DatePicker } from "office-ui-fabric-react";
import moment from "moment";

interface OnboardSDSDatePickerProps {
    onSdsStartDateChanged(SdsStartDate: Date) : void;
    onSdsEndDateChanged(SdsEndDate: Date): void;
    startDate: Date; 
    endDate: Date;
}

interface OnboardSDSDatePickerState {
}

export default class OnboardSdsDatePicker extends Component<OnboardSDSDatePickerProps, OnboardSDSDatePickerState> {

    constructor(props: OnboardSDSDatePickerProps & DispatchProps) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {

    }

    async componentDidUpdate(prevProps: Readonly<OnboardSDSDatePickerProps & DispatchProps>, prevState: OnboardSDSDatePickerState): Promise<void> {
    }

    public render(): JSX.Element {

        return (
            <Fragment>
                <div className="flex-item--flex-1 flex-column flex--align-items-center">
                    <h3>SDS Dates</h3>
                    <DatePicker
                        className={"filter-controls__input"}
                        label={"SDS start date"}
                        value={this.props.startDate}
                        minDate={moment("01-07", "DD-MM").subtract(1, "year").toDate()}
                        onSelectDate={(selectedDate?: Date | undefined | null) => {
                            this.props.onSdsStartDateChanged(selectedDate as Date);
                        }}
                        placeholder="Select a date..."
                        ariaLabel="Select a date"
                        />

                    <DatePicker
                        className={"filter-controls__input"}
                        label={"SDS end date"}
                        value={this.props.endDate}
                        minDate={moment(this.props.startDate).add(1, "day").toDate()}
                        onSelectDate={(selectedDate?: Date | undefined | null) => {
                            this.props.onSdsEndDateChanged(selectedDate as Date);
                        }}
                        placeholder="Select a date..."
                        ariaLabel="Select a date"
                        />
                </div>
            </Fragment>
        )
    }
}
